<script lang="ts">
  import type { Document } from '$shared/models/Document';
  import FileItem from './FileItem.svelte';

  interface Props {
    title?: string;
    disabled?: boolean;
    docs?: Document[];
    selectedItems?: string[];
    onclick?: (doc: Document) => void;
    onopenfile?: (doc: Document) => void;
  }

  let {
    title = '',
    disabled = false,
    docs = [],
    selectedItems = [],
    onclick,
    onopenfile
  }: Props = $props();
</script>

<div class="files">
  {#if title}
    <div class="title">{title}</div>
  {/if}
  {#each docs as doc}
    <FileItem {doc} {selectedItems} {disabled} {onclick} {onopenfile} />
  {:else}
    <div data-cy="empty-content" class="empty-content">No data found</div>
  {/each}
</div>

<style>
  .title {
    font-size: 12px;
    font-weight: 600;
    padding: 16px;
  }
  .empty-content {
    line-height: 30px;
    padding: 0 8px;
    color: var(--grey-medium);
    font-style: italic;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
</style>
